import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import cx from "classnames";
import { createUseStyles } from "react-jss";

// @mui/material components
import { AppBar, Toolbar, Hidden } from "@mui/material";
import { Menu, MoreVert, ViewList } from "@mui/icons-material";

// core components
import AdminNavbarLinks from "./AdminNavbarLinks";
import Button from "../CustomButtons/Button.js";

import styles from "../../assets/jss/material-dashboard-pro-react/components/adminNavbarStyle.js";
import { withTranslation } from "react-i18next";

import stylesModule from "./AdminNavbar.module.scss";

const useStyles = createUseStyles(styles);

const AdminNavbar = (props) => {
    const classes = useStyles();
    const { color } = props;
    const appBarClasses = cx({ [" " + classes[color]]: color });
    return (
        <AppBar className={classes.appBar + appBarClasses}>
            <Toolbar className={classes.container}>
                <div className={stylesModule.hamburger}>
                    <Button
                        className={classes.appResponsive}
                        color="transparent"
                        justIcon
                        aria-label="open drawer"
                        onClick={props.handleDrawerToggle}
                    >
                        <Menu />
                    </Button>
                </div>
                <div className={classes.flex}></div>
                <Hidden smDown implementation="css">
                    <AdminNavbarLinks />
                </Hidden>
            </Toolbar>
        </AppBar>
    );
};

AdminNavbar.propTypes = {
    color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
    brandText: PropTypes.string,
    miniActive: PropTypes.bool,
    handleDrawerToggle: PropTypes.func,
    sidebarMinimize: PropTypes.func,
};

export default withTranslation("", { withRef: true })(AdminNavbar);
